import decodeUnicodeBase64 from './decodeUnicodeBase64';

export default decodeUnicodeBase64;
